import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { withRouter } from 'react-router-dom';

import * as popupActions from '../../actions/popup-actions';
import ActivateUtrUnderAgePopUp from '../PopUps/ActivateUtrUnderAgePopUp';
import SuccessPopupV2 from '../Upgrade/UpgradeToPowerPopupV2/SuccessPopupV2';
import { PopupTypes } from '../../utils/constants';
import UpgradeToPowerPopupV4 from '../Upgrade/UpgradeToPowerPopupV4';
import UpgradePowerMonthlyToAnnualPopup from '../Upgrade/UpgradePowerMonthlyToAnnualPopup';
import MonthlyToAnnualSuccessPopup from '../Upgrade/UpgradePowerMonthlyToAnnualPopup/MonthlyToAnnualSuccessPopup';
import NotReadyForPowerPopup from '../GlobalPrivileges/NotReadyForPowerPopup';
import ResumePowerConfirmPopUp from '../Upgrade/ResumePowerConfirmPopUp';
import SaveToListModal from '../SavedLists/SaveToListModal';
import RemovePlayerConfirmModal from '../SavedLists/RemovePlayerConfirmModal';
import CreateListModal from '../SavedLists/CreateListModal';
import AddPlayerToListModal from '../SavedLists/AddPlayerToListModal';

const PopupContainer = () => {
    const popups = useSelector(({ popups }) => popups);
    const dispatch = useDispatch();
    const {
        activateUtrUnderAge,
        gatedFeature,
        hotelPlannerUpgrade,
        notReadyForPower,
        powerMonthlyUpgrade,
        powerMonthlyUpgradeSuccess,
        powerResumeConfirm,
        powerSuccessV2,
        powerUpgrade,
        saveToList,
        removePlayerConfirm,
        createList,
        addPlayerToList,
        notReadyForPowerRedirectTo,
        referringSurface,
        renewalDate,
        prismicTitle,
        referralCode,
        plansOffered,
        showHotelPlannerCard,
    } = popups || {};

    const onCloseClick = (popUpType) => {
        const onClosePopupFunction = popups[`${popUpType}OnClosePopup`];

        return function onClick() {
            if (onClosePopupFunction) {
                onClosePopupFunction();
            }
            dispatch(popupActions.closePopup(popUpType));
        };
    };

    return (
        <div>
            {activateUtrUnderAge && (
                <ActivateUtrUnderAgePopUp
                    onCloseClick={onCloseClick(PopupTypes.ACTIVATE_UTR_UNDER_AGE_POPUP)}
                />
            )}
            {powerUpgrade && (
                <UpgradeToPowerPopupV4
                    onCloseClick={onCloseClick(PopupTypes.POWER_UPGRADE_POPUP)}
                    // Pinned so the popup keeps this redux slot even when a caller hides the
                    // Hotel Planner card, which the slot used to be inferred from (ENG-2546).
                    popupType={PopupTypes.POWER_UPGRADE_POPUP}
                    showHotelPlannerCard={showHotelPlannerCard !== false}
                    plansOffered={plansOffered}
                    gatedFeature={gatedFeature}
                    referringSurface={referringSurface}
                    prismicTitle={prismicTitle}
                    initialReferralCode={referralCode}
                />
            )}
            {powerSuccessV2 && (
                <SuccessPopupV2
                    onCloseClick={onCloseClick(PopupTypes.POWER_SUCCESS_POPUP_V2)}
                />
            )}
            {powerMonthlyUpgradeSuccess && (
                <MonthlyToAnnualSuccessPopup
                    onCloseClick={onCloseClick(PopupTypes.POWER_MONTHLY_UPGRADE_SUCCESS_POPUP)}
                    renewalDate={renewalDate}
                />
            )}
            {hotelPlannerUpgrade && (
                <UpgradeToPowerPopupV4
                    onCloseClick={onCloseClick(PopupTypes.UPGRADE_TO_POWER_POPUP)}
                    showHotelPlannerCard={false}
                    plansOffered={plansOffered}
                    referringSurface={referringSurface}
                    gatedFeature={gatedFeature}
                    prismicTitle={prismicTitle}
                    initialReferralCode={referralCode}
                />
            )}
            {powerMonthlyUpgrade && (
                <UpgradePowerMonthlyToAnnualPopup
                    onCloseClick={onCloseClick(PopupTypes.POWER_MONTHLY_UPGRADE_POPUP)}
                    referringSurface={referringSurface}
                    gatedFeature={gatedFeature}
                    prismicTitle={prismicTitle}
                />
            )}
            {notReadyForPower && (
                <NotReadyForPowerPopup
                    onCloseClick={onCloseClick(PopupTypes.NOT_READY_FOR_POWER_POPUP)}
                    redirectUrl={notReadyForPowerRedirectTo}
                />
            )}
            {powerResumeConfirm && (
                <ResumePowerConfirmPopUp
                    onCloseClick={onCloseClick(PopupTypes.POWER_RESUME_CONFIRM_POPUP)}
                />
            )}
            {saveToList && (
                <SaveToListModal
                    onCloseClick={onCloseClick(PopupTypes.SAVE_TO_LIST_POPUP)}
                />
            )}
            {removePlayerConfirm && (
                <RemovePlayerConfirmModal
                    onCloseClick={onCloseClick(PopupTypes.REMOVE_PLAYER_CONFIRM)}
                />
            )}
            {createList && (
                <CreateListModal
                    onCloseClick={onCloseClick(PopupTypes.CREATE_LIST_POPUP)}
                />
            )}
            {addPlayerToList && (
                <AddPlayerToListModal
                    onCloseClick={onCloseClick(PopupTypes.ADD_PLAYER_TO_LIST_POPUP)}
                />
            )}
        </div>
    );
};

export default withRouter(PopupContainer);
